import { Link } from 'react-router-dom';
import type { ComicData } from '@/mocks/comics';

interface ComicCardProps {
  comic: ComicData;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.slug}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200">
        <img
          src={comic.coverImage}
          alt={`${comic.title}漫画封面`}
          title={`${comic.title} - 布丁漫画网在线免费阅读`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <span className="inline-block px-2 py-0.5 text-xs font-medium bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full">
            {comic.category}
          </span>
        </div>
        {comic.isHot && (
          <div className="absolute top-2 right-2 w-7 h-7 flex items-center justify-center bg-accent-500 text-background-50 dark:text-foreground-950 text-xs font-bold rounded-full">
            HOT
          </div>
        )}
      </div>
      <div className="mt-3">
        <h3 className="font-heading text-base text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-400">{comic.author}</span>
          <span className="text-xs text-foreground-300">·</span>
          <span className={`text-xs ${comic.status === '连载中' ? 'text-accent-500' : 'text-foreground-400'}`}>
            {comic.status}
          </span>
        </div>
        <div className="flex items-center gap-2 mt-1">
          <span className="flex items-center gap-1 text-xs text-accent-500">
            <i className="ri-star-fill text-[10px]" />
            {comic.rating}
          </span>
          <span className="text-xs text-foreground-300">·</span>
          <span className="text-xs text-foreground-400">
            {(comic.views / 10000).toFixed(1)}万阅读
          </span>
        </div>
      </div>
    </Link>
  );
}